import { Map, Set, OrderedMap } from 'immutable';

import * as types from './types';
import { formatDuration } from './../../time';
import { MetricsRecord } from './../../records';

const initialState = new Map({
  testNames: new Set(),
  tests: [],
  selectedTests: new Map(),
  testSearchValue: '',
  metrics: new OrderedMap({
    runs: new MetricsRecord({
      title: 'Total runs',
      labelClassName: 'blue',
    }),
    errors: new MetricsRecord({
      title: 'Total errors',
      labelClassName: 'warning',
    }),
    fails: new MetricsRecord({
      title: 'Total Failures',
      labelClassName: 'danger',
    }),
    average: new MetricsRecord({
      title: 'Average Runtime',
    }),
  }),
});


const testHistoryReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case types.SET_TEST_SEARCH_VALUE:
      return state
        .set('testSearchValue', payload)
        .set('testNames', new Set());
    case types.GET_TEST_NAMES.REQUEST:
      return state.set('testNames', new Set());
    case types.GET_TEST_NAMES.SUCCESS:
      return state
        .withMutations((newState) => {
          newState.set('testNames', new Set(payload.items.map((item) => item.name)));
        });
    // get test metrics
    case types.GET_TEST_METRICS.SUCCESS:
      return state.withMutations((newState) => {
        const {
          count,
          statuses,
          avgRunTime,
        } = payload.aggs;
        // TODO(adam): omit `statuses` from the backend response if there is no data.
        // Currently, it can be `null` and default value does not work.
        const { errored = 0, failed = 0 } = (statuses || {});

        newState.setIn(['metrics', 'runs', 'value'], count);
        newState.setIn(['metrics', 'errors', 'value'], errored);
        newState.setIn(['metrics', 'fails', 'value'], failed);
        newState.setIn(
          ['metrics', 'average', 'value'],
          avgRunTime ? formatDuration(avgRunTime) : null,
        );
      });
    case types.GET_PREVIOUS_TEST_METRICS.REQUEST:
      return state;
    case types.GET_PREVIOUS_TEST_METRICS.SUCCESS:
      return state.withMutations((newState) => {
        const { count, statuses = {} } = payload.aggs;
        // TODO(adam): omit `statuses` from the backend response if there is no data.
        // Currently, it can be `null` and default value does not work.
        const { errored = 0, failed = 0 } = (statuses || {});

        newState.setIn(['metrics', 'runs', 'previousValue'], count);
        newState.setIn(['metrics', 'errors', 'previousValue'], errored);
        newState.setIn(['metrics', 'fails', 'previousValue'], failed);
      });
    case types.GET_PREVIOUS_TEST_METRICS.FAILURE:
      return state;
    case types.GET_TESTS.REQUEST:
      return state.withMutations((newState) => {
        // if there is no 'from' param, it means we start getting tests from scratch
        if (!payload.from) {
          newState.set('tests', []).set('selectedTests', new Map());
        }

        return newState;
      });
    case types.GET_TESTS.SUCCESS:
      return state.withMutations((newState) => {
        newState.update('tests', (tests) => tests.concat(
          payload.items.map(
            (item) => ({ ...item, timestamp: Date.parse(item.creation_time) }),
          ),
        ));
      });
    case types.ADD_TO_SELECTED_TESTS:
      return state.setIn(['selectedTests', payload.id], payload);
    case types.REMOVE_FROM_SELECTED_TESTS:
      return state.deleteIn(['selectedTests', payload.id]);
    case types.CLEAR_SELECTED_TESTS:
      return state.withMutations((newState) => {
        // Reset tests to clear selected point from scatterplot
        newState
          .set('selectedTests', new Map())
          .set('tests', state.get('tests').slice(0));
      });
    default:
      return state;
  }
};

export default testHistoryReducer;
export { initialState };
